import React, { useEffect, useState } from "react";
import { Skeleton, Typography } from "antd";
import { useTranslation } from "react-i18next";
import "./deliveryAddress.css";
import {
  getAllSavedAddress,
  showGoBackButton,
} from "../../../slices/SavedAddressSlice";
import SavedAddress from "./savedAddress";
import { useDispatch, useSelector } from "react-redux";
import AddDeliveryAddress from "./addDeliveryAddress";
import { generateDynamicStyling, isDateInRange, isEmpty } from "../../../Utils/utils";
import { PlusCircleOutlined } from "@ant-design/icons";
import {
  collpaseAddressComponent,
  updateShopperDetails,
  selectBaseColor,
  updateSavedAddressData,
  getAllPaymentMethods,
  updatePaymentMethodDictionary,
} from "../../../slices/PaymentSessionDetailsSlice";
import CollpaseAddress from "./collpaseAddress";
import { removePostalData } from "../../../slices/PostalCodeSlice";
import {
  selectMobileNumber,
  selectSessionToken,
  selectShowLogin,
} from "../../../slices/ShopperInfoSlice";
import { selectSavedInstruments } from "../../../slices/SavedInstrumentSlice";
import { addressAnalyticsEvent } from "../../../Utils/uiAnalytics";
import BasicDetails from "./basicDetails";
import TranslateText from "../../resuableComponents/TranslateText";

export default function DeliveryAddress() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const shopperRef = useSelector((state) => selectMobileNumber(state));
  const sessionToken = useSelector((state) => selectSessionToken(state));
  const addressCollapse = useSelector((state) => state.paymentSessionDetails?.addressCollapse);
  const allSavedAddresses = useSelector((state) => state.savedAddressDetails?.allSavedAddresses);
  const sessionDetails = useSelector((state) => state.paymentSessionDetails?.sessionDetails);
  const savedAddress = useSelector((state) => state.savedAddressDetails?.savedAddress);
  const updatedSavedAddressData = useSelector((state) => state.savedAddressDetails?.updatedSavedAddressData);
  const { showEmailAddress, showFullName, showContactNumber, showPan, showDob } = useSelector((state) => state.additionalComponents) || {}
  const paymentMethodsBasedOnCountry = useSelector((state) => state.paymentSessionDetails?.paymentMethodsBasedOnCountry);
  const latestSavedAddress = useSelector((state) => state.paymentSessionDetails?.latestSavedAddress);
  const sampleToken = useSelector((state) => state.paymentSessionDetails?.sampleToken);
  const savedInstruments = useSelector((state) => selectSavedInstruments(state));
  const isShippingAddressDisplay = useSelector((state) => state.paymentSessionDetails?.isShippingAddressDisplay);
  const showLogin = useSelector(selectShowLogin);
  const guestCheckout = useSelector((state) => state.shopperInfo?.guestCheckout);
  const baseColor = useSelector((state) => selectBaseColor(state));
  const [loading, setLoading] = useState(true);
  const [componentRendered, setComponentRendered] = useState(false);
  const [showAddAddressOption, setShowAddAddressOption] = useState(true);
  const [selectedCardData, setSelectedCardData] = useState("");
  const [addressFieldValue, setAddressFieldValue] = useState({});
  const [showCancelButton, setShowCancelButton] = useState(false);
  const [editAddressItem, setEditAddressItem] = useState("");
  const [selectedCardButton, setSelectedCardButton] = useState("");
  const browserCountry = useSelector((state) => state.paymentSessionDetails?.browserCountry);
  const appliedOfferDetail = useSelector(state => state.offers?.appliedOfferDetail)
  const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isLoggedIn = useSelector((state) => state.shopperInfo.isLoggedIn);
  const searchParams = new URLSearchParams(document.location.search);
  const checkoutTokenParams = searchParams.get("token")


  useEffect(() => {
    setComponentRendered(true);
  }, []);
  useEffect(() => {
    if (sessionDetails) {
      generateDynamicStyling(sessionDetails);
    }
  }, [sessionDetails]);
  useEffect(() => {
    let newShopperRef = !isEmpty(shopperRef) ? shopperRef : localStorage.getItem('shopperRef');
    if (componentRendered && !guestCheckout && !sampleToken && isLoggedIn && !isEmpty(newShopperRef)) {
      dispatch(getAllSavedAddress({ shopperRef: newShopperRef, sessionToken, checkoutToken: checkoutTokenParams || sessionDetails?.token }))
        .then(() => setLoading(false))
        .catch(() => setLoading(false));
    }
  }, [componentRendered, guestCheckout, dispatch, sampleToken, isLoggedIn, sessionDetails, shopperRef]);
  useEffect(() => {
    if (guestCheckout) {
      setLoading(false);
    }
  }, [guestCheckout]);
  useEffect(() => {
    if (sampleToken) {
      setLoading(false);
    }
  }, [sampleToken]);
  useEffect(() => {
    if (!showLogin) {
      setLoading(false);
    }
  }, [showLogin]);
  useEffect(() => {
    if (allSavedAddresses?.length > 0) {
      setShowAddAddressOption(false);
      setShowCancelButton(true);
      dispatch(showGoBackButton(true));
    } else {
      setShowAddAddressOption(true);
      setEditAddressItem("");
      setAddressFieldValue({});
      dispatch(removePostalData());
      setShowCancelButton(false);
      dispatch(showGoBackButton(false));
    }
  }, [allSavedAddresses, dispatch]);
  useEffect(() => {
    if (savedAddress && Object.keys(savedAddress)?.length) {
      const selectedCardData = savedAddress;
      setShowAddAddressOption(false);
      dispatch(updateSavedAddressData(selectedCardData));
      dispatch(updateShopperDetails({ selectedCardData }));
      dispatch(collpaseAddressComponent());
      dispatch(
        getAllPaymentMethods({
          token: sessionDetails?.token,
          countryCode: savedAddress?.countryCode,
          browserTimeZone: browserTimeZone,
          ...(appliedOfferDetail?.codes?.length && { offerId: appliedOfferDetail.codes[0] })
        })
      );
    }
  }, [savedAddress]);

  const handleSelectedEditAddress = (item) => {
    setEditAddressItem(item);
  };
  const handleSelectedCardData = (item) => {
    setSelectedCardData(item);
  };
  const handleButtonClicked = (item) => {
    setSelectedCardButton(item);
  };
  useEffect(() => {
    if (Object.keys(editAddressItem)?.length) {
      setShowAddAddressOption(true);
      setAddressFieldValue(editAddressItem);
      dispatch(removePostalData());
      dispatch(
        getAllPaymentMethods({
          token: sessionDetails?.token,
          countryCode: editAddressItem?.countryCode,
          browserTimeZone: browserTimeZone,
          ...(appliedOfferDetail?.codes?.length && { offerId: appliedOfferDetail.codes[0] })
        })
      );
    }
  }, [editAddressItem]);
  useEffect(() => {
    if (updatedSavedAddressData && Object.keys(updatedSavedAddressData)?.length > 0) {
      const selectedCardData = updatedSavedAddressData;
      setShowAddAddressOption(false);
      dispatch(updateSavedAddressData(selectedCardData));
      dispatch(updateShopperDetails({ selectedCardData }));
      dispatch(collpaseAddressComponent());
      dispatch(
        getAllPaymentMethods({
          token: sessionDetails?.token,
          countryCode: updatedSavedAddressData?.countryCode,
          browserTimeZone: browserTimeZone,
          ...(appliedOfferDetail?.codes?.length && { offerId: appliedOfferDetail.codes[0] })
        })
      );
    }
  }, [updatedSavedAddressData]);
  useEffect(() => {
    if (selectedCardData && Object.keys(selectedCardData)?.length > 0 && selectedCardButton) {
      dispatch(updateShopperDetails({ selectedCardData }));
      dispatch(collpaseAddressComponent());
      dispatch(
        getAllPaymentMethods({
          token: sessionDetails?.token,
          browserTimeZone: browserTimeZone,
          countryCode: selectedCardData?.countryCode,
          ...(appliedOfferDetail?.codes?.length && { offerId: appliedOfferDetail.codes[0] })
        })
      );
    }
  }, [selectedCardData, selectedCardButton]);


  const handleGuestData = (item) => {
    const selectedCardData = item;
    setShowAddAddressOption(false);
    dispatch(updateSavedAddressData(selectedCardData));
    dispatch(updateShopperDetails({ selectedCardData }));
    dispatch(collpaseAddressComponent());
  };
  useEffect(() => {
    if (paymentMethodsBasedOnCountry) {
      if (savedInstruments?.length > 0 && !appliedOfferDetail?.codes?.length) {
        dispatch(
          updatePaymentMethodDictionary({
            Recommended: savedInstruments,
          })
        );
      } else {
        // dispatch(updatePaymentMethodDictionary({}));
      }
    }
  }, [paymentMethodsBasedOnCountry, savedInstruments, appliedOfferDetail]);

  const isAddressComponentBeOpened = (shopper) => {
    const { name, email, phoneNumber, panNumber, dateOfBirth, countryCode, postalCode, state, address1, address2, city } = shopper;
    return {
      check: (!showFullName || (showFullName && !isEmpty(name))) &&
        (!showEmailAddress || (showEmailAddress && !isEmpty(email))) &&
        (!showContactNumber || (showContactNumber && !isEmpty(phoneNumber))) &&
        (!showDob || (showDob && !isEmpty(dateOfBirth) && isDateInRange(dateOfBirth))) &&
        (!showPan || (showPan && !isEmpty(panNumber))) &&
        (!isShippingAddressDisplay || (isShippingAddressDisplay &&
          (countryCode && postalCode && state && address1 && city)
        )),
      shopperData: {
        name: name,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        countryCode: countryCode,
        postalCode: postalCode,
        email: email,
        phoneNumber: phoneNumber,
        panNumber: panNumber,
        dateOfBirth: dateOfBirth,
      }
    };
  }

  const handleSessionDetails = () => {
    const { firstName, lastName } = { ...sessionDetails?.paymentDetails?.shopper };
    const fullName = `${firstName || ''} ${lastName || ''}`;
    const { countryCode, postalCode, state, address1, address2, city } = { ...sessionDetails?.paymentDetails?.shopper?.deliveryAddress }

    let tempData = {
      name: fullName,
      ...sessionDetails?.paymentDetails?.shopper,
      countryCode,
      postalCode,
      state,
      address1,
      address2,
      city
    }
    return { ...tempData };
  }

  const hasFullShippingAddress = (a) =>
    a && a.address1 && a.city && a.state && a.countryCode && a.postalCode;

  const resolveAddressSource = () => {
    if (!isEmpty(latestSavedAddress) && (!isShippingAddressDisplay || hasFullShippingAddress(latestSavedAddress))) {
      return latestSavedAddress;
    }
    return handleSessionDetails();
  };

  useEffect(() => {
    if (sampleToken || isLoggedIn === false) {

      let isCollapsedAddress = false;
      let shopperData = {};
      if (!isEmpty(latestSavedAddress)) {
        isCollapsedAddress = isAddressComponentBeOpened(latestSavedAddress).check;
        shopperData = isAddressComponentBeOpened(latestSavedAddress).shopperData;
      } else {
        isCollapsedAddress = isAddressComponentBeOpened(handleSessionDetails()).check;
        shopperData = isAddressComponentBeOpened(handleSessionDetails()).shopperData;
      }
      if (isCollapsedAddress) {
        const { check: isCollapsedAddress, shopperData } = isAddressComponentBeOpened(resolveAddressSource());
        if (isCollapsedAddress) {
          if (isEmpty(latestSavedAddress) || (isShippingAddressDisplay && !hasFullShippingAddress(latestSavedAddress))) {
            dispatch(updateSavedAddressData(shopperData));
          }
          dispatch(updateShopperDetails({ selectedCardData: shopperData }));
          dispatch(collpaseAddressComponent());
        }
        return
      }
    }
  }, [sampleToken, sessionDetails, showLogin, latestSavedAddress, isLoggedIn, isShippingAddressDisplay]);

  if (loading) {
    return <Skeleton active size="large" />;
  }
  return (
    <>
      {isShippingAddressDisplay ? (
        <div className="deliveryForm">
          <div className="deliveryAddressHeader">
            <div className="headerDiv">
              <img
                src="/assets/address/delivery.svg"
                alt="delivery"
                className="truck"
              />
              <Typography className="deeliveryHeading dynamic-font-family">
                <TranslateText label={"DELIVERY_ADDRESS"}>Delivery Address</TranslateText>
              </Typography>
            </div>
            {!showAddAddressOption && !addressCollapse && (
              <div
                className="addNewAddress"
                onClick={() => {
                  setShowAddAddressOption(true);
                  setAddressFieldValue({});
                  dispatch(removePostalData());
                }}
              >
                <PlusCircleOutlined style={{ color: baseColor }} />
                <Typography
                  className="add-new-address"
                  style={{ color: baseColor }}
                >
                  <TranslateText label={"ADD_NEW_ADDRESS"}>Add New Address</TranslateText>
                </Typography>
              </div>
            )}
          </div>
          <div>
            {addressCollapse && latestSavedAddress ? (
              <CollpaseAddress
                setShowAddAddressOption={setShowAddAddressOption}
                setSelectedCardButton={setSelectedCardButton}
                setAddressFieldValue={setAddressFieldValue}
              />
            ) : (
              <div className="mainAddressDiv">
                {!showAddAddressOption ? (
                  <SavedAddress
                    handleSelectedEditAddress={handleSelectedEditAddress}
                    handleSelectedCardData={handleSelectedCardData}
                    handleButtonClicked={handleButtonClicked}
                    setAddressFieldValue={setAddressFieldValue}
                  />
                ) : (
                  <>
                    <AddDeliveryAddress
                      addressFieldValue={addressFieldValue}
                      selectedAddressItem={editAddressItem}
                      setShowAddAddressOption={setShowAddAddressOption}
                      showCancelButton={showCancelButton}
                      setSelectedAddressItem={setEditAddressItem}
                      handleGuestData={handleGuestData}
                    />
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <BasicDetails
          addressFieldValue={addressFieldValue}
          setShowAddAddressOption={setShowAddAddressOption}
          setSelectedCardButton={setSelectedCardButton}
          setAddressFieldValue={setAddressFieldValue}
          handleGuestData={handleGuestData}
        />
      )}
    </>
  );
}